import { PageHero, Reveal } from "@/components/site/Motion";

const SECTIONS = [
  {
    title: "Éditeur du site",
    lines: [
      "L'effet poilus — Sophie Reitzer, entrepreneure individuelle",
      "Immatriculation en cours (SIRET en cours d'attribution)",
      "Zone d'activité : Coutances, Saint-Lô, Granville, Portbail-sur-Mer et communes alentour",
      "Email : sophie_reitzer@hotmail.fr",
    ],
  },
  {
    title: "Directrice de la publication",
    lines: ["Sophie Reitzer"],
  },
  {
    title: "Hébergement",
    lines: ["Ce site est hébergé sur la plateforme Emergent (emergent.sh)."],
  },
  {
    title: "Propriété intellectuelle",
    lines: [
      "L'ensemble des contenus du site (textes, logo, photographies) est la propriété exclusive de L'effet poilus. Toute reproduction, représentation ou utilisation sans autorisation préalable est interdite.",
    ],
  },
  {
    title: "Données personnelles",
    lines: [
      "Les informations transmises via le formulaire de contact (nom, email, téléphone, message) sont utilisées uniquement pour vous recontacter dans le cadre de votre demande. Elles ne sont ni cédées ni vendues à des tiers.",
      "Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer : sophie_reitzer@hotmail.fr.",
    ],
  },
  {
    title: "Cookies",
    lines: ["Ce site n'utilise pas de cookies publicitaires ni de traceurs marketing."],
  },
];

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-legales-page">
      <PageHero
        testId="mentions-hero"
        overline="Informations légales"
        lines={[{ text: "Mentions" }, { text: "légales.", accent: true }]}
        intro="Les informations ci-dessous s'appliquent à l'ensemble de ce site, édité par L'effet poilus."
      />
      <section className="px-6 pb-24 sm:px-10 md:pb-32 lg:px-16" data-testid="mentions-sections">
        <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
          {SECTIONS.map((section, i) => (
            <Reveal key={section.title} delay={0.06 * i} y={32}>
              <article
                className="h-full rounded-[2rem] border border-stone-border bg-white/70 p-9"
                data-testid={`legal-section-${i + 1}`}
              >
                <h2 className="font-serif text-2xl font-medium text-ink">{section.title}</h2>
                <div className="mt-4 space-y-3">
                  {section.lines.map((line) => (
                    <p key={line} className="text-sm leading-relaxed text-ink/65">
                      {line}
                    </p>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
